import React, { useState } from 'react';
import { Play } from "lucide-react";

interface VideoCardProps {
    title: string;
    videoId: string;
    description?: string;
}

const VideoCard = ({ title, videoId, description }: VideoCardProps) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            setIsModalOpen(false);
        }
    };

    return (
        <>
            {/* Card */}
            <div className="group overflow-hidden transform transition-all duration-500 hover:scale-[1.02] bg-white/5 backdrop-blur-sm border border-white/5 hover:border-market-teal/20 hover:shadow-[0_0_30px_rgba(74,222,128,0.15)] w-full">
                {/* Responsive aspect-ratio container */}
                <div className="relative w-full aspect-video overflow-hidden">
                    <img
                        src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
                        alt={title}
                        className="w-full h-full object-cover transform transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <button
                            onClick={() => setIsModalOpen(true)}
                            className="w-12 h-12 rounded-full flex items-center justify-center bg-market-teal text-black transform scale-75 group-hover:scale-100 transition-all duration-300"
                        >
                            <Play className="w-6 h-6 ml-1" />
                        </button>
                    </div>
                </div>

                {/* Title & Description */}
                <div className="p-4 space-y-2">
                    <h3 className="text-lg font-semibold text-white/90 group-hover:text-market-teal border-market-teal transition-colors">
                        {title}
                    </h3>
                    {description && (
                        <p className="text-sm text-gray-400">{description}</p>
                    )}
                </div>
            </div>

            {/* Modal */}
            {isModalOpen && (
                <div
                    className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center px-4"
                    onClick={handleOverlayClick}
                >
                    <div className="w-full max-w-6xl">
                        {/* Maintain 16:9 aspect ratio */}
                        <div className="relative w-full pt-[56.25%]">
                            <iframe
                                className="absolute top-0 left-0 w-full h-full rounded-lg"
                                src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                                title={title}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default VideoCard;
